import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import ModalSearchFormBtn from '@/components/forms/ModalSearchFormBtn';
import { cn } from '@/lib/cn';
import { formatCurrency } from '@/lib/formatCurrency';
import type { CatalogItem } from '@/services/rental-api-client';
export type FleetCategoryTeaserProps = {
  fleetCategory: CatalogItem;
};
export function FleetCategoryTeaser(t0) {
  const $ = _c(20);
  const {
    fleetCategory
  } = t0;
  const image = fleetCategory.studioImage || fleetCategory.scenicImage;
  const t1 = !image;
  let t2;
  if ($[0] !== t1) {
    t2 = cn("rounded-full border border-base-125 p-2 pl-6 md:p-4 flex gap-4 items-center relative min-w-81 md:w-105 bg-white mx-auto card-shadow", {
      "md:pl-0": t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== fleetCategory.name || $[3] !== image) {
    t3 = image ? <div className="aspect-[13/8] w-[78px] relative hidden md:block"><Image src={image} className="object-contain" fill={true} alt={fleetCategory.name} sizes="78px" /></div> : null;
    $[2] = fleetCategory.name;
    $[3] = image;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== fleetCategory.name) {
    t4 = <small className="text-sm leading-[22px] font-semibold">{fleetCategory.name}</small>;
    $[5] = fleetCategory.name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== fleetCategory.estimatedDailyRate) {
    t5 = fleetCategory.estimatedDailyRate ? <small className="text-xs leading-[19px] text-neutral-800 ">from {formatCurrency(fleetCategory.estimatedDailyRate)}/day</small> : null;
    $[7] = fleetCategory.estimatedDailyRate;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex flex-col gap-0 justify-center items-start flex-1 relative w-full">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== fleetCategory.code || $[13] !== fleetCategory.fleetTypeSlug) {
    t7 = <ModalSearchFormBtn className="btn btn-primary h-13 w-27" values={{
      fleetType: fleetCategory.fleetTypeSlug,
      fleetCategoryCode: fleetCategory.code
    }} openStep="locations">Book now</ModalSearchFormBtn>;
    $[12] = fleetCategory.code;
    $[13] = fleetCategory.fleetTypeSlug;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t2}>{t3}{t6}{t7}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}